module.exports = __webpack_public_path__ + "static/media/go_to_gallery_green.1b5bd7b4.svg";